module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioSegundoExamenAdminProyectos.e63a0d3e.pdf";